module.exports = __webpack_public_path__ + "img/gb-sct.ebae9594.svg";